import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { open } from '../../../../modules/modal/actions';
import {
  OPEN_BET_REASON_INSUFFICIENT_BALANCE,
  OPEN_BET_REASON_PMB_LOCKED,
  OPEN_BET_REASON_WINNINGS_LOCKED,
  REASON_WITHDRAWAL_DECLINED
} from '../../../withdraw/errors';
import Translation from '../../../i18n/Translation';
import PaymentMethodBalanceFailed from './PaymentMethodBalanceFailed';

const mapDispatchToProps = {
  showLearnMore: open.bind(null, { componentName: 'WithdrawalInfo' })
};

const LOCKED_REASONS = [
  OPEN_BET_REASON_WINNINGS_LOCKED,
  OPEN_BET_REASON_PMB_LOCKED
];

const getPlusPaymentMethodBalance = details => {
  if (!details || details.reason !== REASON_WITHDRAWAL_DECLINED || !details.balances) {
    return null;
  }

  const { plusPaymentMethodBalance } = details.balances;
  if (plusPaymentMethodBalance === null
    || plusPaymentMethodBalance === undefined
    || String(plusPaymentMethodBalance).trim() === '') {
    return null;
  }

  const balance = Number(plusPaymentMethodBalance);
  return Number.isFinite(balance) ? Math.max(balance, 0) : null;
};

const GenericWithdrawFailed = ({ showLearnMore }) => (
  <div>
    <Translation section="withdraw" label="requestError" />{' '}
    <span className="withdraw-failed__link" onClick={showLearnMore}>
      <Translation section="common" label="learnMore" />
    </span>
  </div>
);

GenericWithdrawFailed.propTypes = {
  showLearnMore: PropTypes.func.isRequired
};

export const WithdrawFailed = ({ showLearnMore, details }) => {
  const isWithdrawalDeclined = details && details.reason === REASON_WITHDRAWAL_DECLINED;

  if (isWithdrawalDeclined
    && details.openBetReason === OPEN_BET_REASON_INSUFFICIENT_BALANCE) {
    return (
      <div>
        <Translation section="withdraw" label="insufficientBalance" />
      </div>
    );
  }

  const balance = getPlusPaymentMethodBalance(details);
  if (isWithdrawalDeclined
    && LOCKED_REASONS.includes(details.openBetReason)
    && balance !== null) {
    return <PaymentMethodBalanceFailed balance={balance} />;
  }

  return <GenericWithdrawFailed showLearnMore={showLearnMore} />;
};

WithdrawFailed.propTypes = {
  showLearnMore: PropTypes.func.isRequired,
  details: PropTypes.shape({
    reason: PropTypes.string,
    openBetReason: PropTypes.string,
    balances: PropTypes.shape({
      plusPaymentMethodBalance: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ])
    })
  })
};

export default connect(null, mapDispatchToProps)(WithdrawFailed);
